import {colors} from "@c10h/colors";
import {Trans} from "ni18n";
import React from "react";
import states from "us-state-codes/states.json";

import styles from "./CoverageMap.module.scss";
import {IllustratedTextDecoration} from "./IllustratedTextDecoration";

interface Props {
  coveredStates: string[];
}

const CoverageMap = ({coveredStates}: Props) => {
  const notStates = ["PR", "DC"];

  const count = coveredStates.length;

  const allStates = states
    .getKeys()
    .filter(code => !notStates.includes(code))
    .map(code => ({
      code,
      // @ts-expect-error TS7053: Element implicitly has an 'any' type because expression of type 'string' can't be used to index type '{ AL: string; AK: string; AZ: string; AR: string; CA: string; CO: string; CT: string; DE: string; DC: string; FL: string; GA: string; HI: string; ID: string; IL: string; IN: string; IA: string; KS: string; KY: string; ... 33 more ...; WY: string; }'.
      name: states[code],
      isCovered: coveredStates.includes(code),
    }));

  const renderedStates = allStates.map(({code, name, isCovered}) => (
    <div
      key={code}
      className={`${styles.state} ${isCovered ? "" : styles["not-covered"]}`}
      style={{
        "--gridArea": code,
        backgroundColor: isCovered ? colors.darkerMint : colors.gray100,
        color: isCovered ? "#fff" : colors.gray200,
      }}
    >
      <span className={styles["state-code"]}>{code}</span>
      <span className={styles["state-name"]}>{name}</span>
    </div>
  ));

  const formattedCoveredStates = allStates.filter(s => s.isCovered);
  const coveredStateNames = formattedCoveredStates.map(st => st.name).append("Washington D.C.");
  const half = Math.floor(count / 2);
  const listColumns = [coveredStateNames.slice(0, half), coveredStateNames.slice(half, count)];

  return (
    <div className={`df fdc aic bg-gray50 pv30 pv10-md pv8-sm ${styles.outer}`}>
      <div className={`maxw80 maxw30-md maxw22-sm df-f-md fdc-f-md aifs-md pb8-md ${styles.inner}`}>
        <h2
          className={`tac tal-md fs48 fs36-md fs32-sm fs24-xs mb10 mb4-lg pl18-md pl4-sm ${styles.header}`}
        >
          <Trans count={count}>
            Currently offered in{" "}
            <span className="darkerGreen pos-r wsnw">
              <>
                {{count}} states
                <IllustratedTextDecoration type="underline" />
              </>
            </span>
          </Trans>
        </h2>
        <div className={`df jcc aic ph10 ph0-sm pt10 pt4-sm ${styles.list}`}>
          <div className="df">
            {listColumns.map((list, i) => (
              <div key={`list-${i}`} className="df fdc ml8 ml6-sm">
                {list.map(state => (
                  <div
                    key={`list-${state}`}
                    className="df aic fs20 fs18-lg fs14-xs mb6 mb4-lg font-ir-xs"
                  >
                    <span className="bg-green br50 mr2" style={{height: 4, width: 4}} />
                    {state}
                  </div>
                ))}
              </div>
            ))}
          </div>
        </div>
        <div className={`dn-md ${styles.map}`}>{renderedStates}</div>
      </div>
    </div>
  );
};

export default CoverageMap;
